import React, { useState } from 'react';
import { SpeedDial, SpeedDialAction } from '@mui/material';
import { Add as AddIcon, FileCopy as FileCopyIcon, People as PeopleIcon, Money as MoneyIcon, AccessTime as AccessTimeIcon, Receipt as ReceiptIcon, Assignment as AssignmentIcon, CloudUpload as CloudUploadIcon } from '@mui/icons-material';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

const SpeedDialMenu = ({ style }) => {
  const { t } = useTranslation('navigation');
  const navigate = useNavigate();
  const [open, setOpen] = useState(false);

  const actions = [
    { icon: <FileCopyIcon />, name: t('speedDial.files'), action: () => navigate('/files/create') },
    { icon: <PeopleIcon />, name: t('speedDial.relationships'), action: () => navigate('/relationships/create') },
    { icon: <AccessTimeIcon />, name: t('speedDial.timesheet'), action: () => navigate('/timesheets/create') },
    { icon: <ReceiptIcon />, name: t('speedDial.invoice'), action: () => navigate('/finance/create-invoice') },
    { icon: <AssignmentIcon />, name: t('speedDial.tasks'), action: () => navigate('/task/create') },
    { icon: <CloudUploadIcon />, name: t('speedDial.uploadDocument'), action: () => navigate('/documents/upload') },
  ];

  return (
    <div style={{ ...style, position: 'fixed', bottom: '20px', right: '20px', zIndex: 1000, pointerEvents: 'none' }}>
      <SpeedDial
        ariaLabel="SpeedDial example"
        icon={<AddIcon />}
        direction="up"
        onClose={() => setOpen(false)}
        onOpen={() => setOpen(true)}
        open={open}
        FabProps={{
          style: {
            backgroundColor: '#ECF0F1',
            color: '#2C3E50',
            zIndex: 100000,
            width: '56px',
            height: '56px',
            pointerEvents: 'auto',
          }
        }}
      >
        {actions.map((action) => (
          <SpeedDialAction
            key={action.name}
            icon={action.icon}
            tooltipTitle={action.name}
            onClick={action.action}
          />
        ))}
      </SpeedDial>
    </div>
  );
};

export default SpeedDialMenu;